import * as React from "react";

interface Props {
  title: string;
  action?: React.ReactNode;
}
const dataElmId = "controlOptionSection";

const ControlOptionFC: React.FC<React.PropsWithChildren<Props>> = ({ children, title, action }) => {
  return (
    <div className="w-full py-2.5">
      <div className="w-full pr-[10px] m-0">
        <div className="flex justify-between items-baseline w-full p-0 m-0">
          <div
            className="font-semibold text-sm text-slate-800 dark:text-slate-200 pb-0.5 mb-0 select-none"
            data-elm-id={`${dataElmId}_title_${title.replace(" ", "_")}`}
          >
            {title}
          </div>
          {action}
        </div>
        <div className="p-0 w-full mt-1.5">{children}</div>
      </div>
    </div>
  );
};

export const ControlOption = ControlOptionFC;
